import { ICreateDocumentoUseCase } from "../../../presentation/useCases/create/create_documento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CreateDocumentoUseCase
 */

export class CreateDocumentoUseCase implements ICreateDocumentoUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async createDocumento(
    idFuncionario: number,
    statusArquivo: number | null,
    nomeDocumento: string,
    dataVencimento: Date | null,
    dataEmissao: Date | null,
    file: File | null,
  ): Promise<void> {
    await this.repository.createDocumento(
      idFuncionario,
      nomeDocumento,
      statusArquivo,
      dataVencimento,
      dataEmissao,
      file,
    );
  }
}